module.exports = "<div class=\"form-group has-feedback\"><input class=\"form-control custom-datepicker\" name={{name}} ng-model=myDate ng-click=\"opened = true\" uib-datepicker-popup=dd/MM/yyyy is-open=opened show-button-bar=false shortcut-propagation=true datepicker-options=datepickerOptions ng-required=\"{{required}}\"> <span class=\"glyphicon glyphicon-calendar form-control-feedback\"></span></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/html-loader!./app/widgets/customDatepicker/custom-datepicker.html
 ** module id = 174
 ** module chunks = 0
 **/